import {UIGameTimerController} from '../../../shared/scripts/ui_game/UIGameTimerController'
import {TextView} from '../../../shared/scripts/ui_canvas_engine/TextView'
import {GameFont} from '../../../shared/scripts/GameFont'
import {GameColor} from '../../../shared/scripts/GameColor'
import {TranslationObject} from '@colonist/i18n'
import {turnSecondsInToTimerFormat} from '../../../shared/scripts/ui_utils/ClientUtils'
import {UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager'
import {createDivIn} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {PlayerColor} from '@colonist/game-states'

export class UIMGameTimerController extends UIGameTimerController {
    private readonly tickerElement: HTMLElement | undefined
    protected readonly defaultTimerColor: GameColor.Color = GameColor.Color.White
    private currentPlayerColor: PlayerColor

    private pauseStartTime: number = 0
    private totalPauseTime: number = 0

    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)
        const body = document.getElementsByTagName('body')[0]
        const tickerParentElement = createDivIn(body, 'm-ticker-parent')
        this.tickerElement = createDivIn(tickerParentElement, 'm-ticker')
        this.tickerElement.classList.add('active')
    }

    createText(): TextView {
        const canvas = this.uiGameManager.canvasController
        const fontSize = GameFont.Size.XL * 0.9
        const statusBarHeight = UIMDeviceHandler.getStatusBarHeight()

        const w = UIUtilsEjsVariables.isUserOnTabletApp ? canvas.itemSize * 3 : canvas.itemSize * 1.5
        const h = canvas.itemSize / 5
        const x = canvas.appW - 4 * canvas.margin - w
        const y = statusBarHeight + (this.uiGameManager.gameLayout.getHelpSectionHeight() - statusBarHeight - fontSize) / 2
        const text: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: turnSecondsInToTimerFormat(this.secondsLeft)}}
        const textView = new TextView(text, x, y, w, h, canvas.app.stage, fontSize, GameColor.getColor(GameColor.Color.White))
        textView.makeBold()
        textView.changeStyle({align: 'right'})
        return textView
    }

    protected updateTimeText(): void {
        super.updateTimeText()
        this.updateTicker()
        this.alignTimerToRight()
    }

    private alignTimerToRight() {
        const canvas = this.uiGameManager.canvasController
        const margin = canvas.itemSize / 8
        this.textView.x = canvas.appW - this.textView.width - margin
    }

    private updateTicker(): void {
        const timeLeft = this.secondsLeft
        const timePassed = (new Date().valueOf() - this.uiGameManager.gameController.currentState.startTime - this.totalPauseTime) / 1000
        const timeLeftPercentage = (timeLeft / (timePassed + timeLeft)) * 100
        if(!this.tickerElement) return

        const hasPlayerChanged = this.currentPlayerColor !== this.uiGameManager.gameController.currentState.currentTurnPlayerColor
        if(hasPlayerChanged) {
            this.currentPlayerColor = this.uiGameManager.gameController.currentState.currentTurnPlayerColor
            this.tickerElement.style.backgroundColor = GameColor.getPlayerBGDarkHashForMobile(this.uiGameManager.gameController.currentState.currentTurnPlayerColor)
            this.tickerElement.classList.remove('active')
            this.totalPauseTime = 0
        } else if(!this.tickerElement.classList.contains('active')) {
            this.tickerElement.classList.add('active')
        }
        this.tickerElement.style.width = `${timeLeftPercentage}%`
    }

    protected pauseTimer(): void {
        super.pauseTimer()
        this.pauseStartTime = new Date().valueOf()
    }

    protected resumeTimer(): void {
        super.resumeTimer()
        if(this.pauseStartTime == 0) return
        this.totalPauseTime += new Date().valueOf() - this.pauseStartTime
        this.pauseStartTime = 0
    }

    protected onBeginnerModeStart(): void {
        this.textView.visible = false
    }
}
